import { render, staticRenderFns } from "./dialog-dashboardinbox.vue?vue&type=template&id=5cd9441f&"
import script from "./dialog-dashboardinbox.vue?vue&type=script&lang=js&"
export * from "./dialog-dashboardinbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports